export const setOverflowAuto = () => {
  document.querySelector('.app') && document.querySelector('.app').classList.add('app_type-overflow-auto');
};

export const removeOverflowAuto = () => {
  document.querySelector('.app') && document.querySelector('.app').classList.remove('app_type-overflow-auto');
};
